
import React from 'react';
import { motion } from 'framer-motion';

interface SkeletonProps {
  className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({ className }) => {
  return (
    <div className={`bg-gray-200 animate-pulse rounded-md ${className}`} />
  );
};

export const TableSkeleton: React.FC = () => {
  return (
    <div className="w-full space-y-4">
      <div className="flex gap-4 mb-8">
        <Skeleton className="h-12 w-64 rounded-2xl" />
        <Skeleton className="h-12 w-32 rounded-2xl" />
      </div>
      <div className="bg-white rounded-[2rem] border border-gray-100 overflow-hidden">
        <div className="p-6 border-b border-gray-50 flex gap-4">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-24 ml-auto" />
        </div>
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="p-6 flex items-center gap-6 border-b border-gray-50 last:border-0">
            <Skeleton className="h-12 w-12 rounded-xl" />
            <div className="space-y-2 flex-1">
              <Skeleton className="h-4 w-1/4" />
              <Skeleton className="h-3 w-1/6" />
            </div>
            <Skeleton className="h-8 w-24 rounded-lg" />
            <Skeleton className="h-8 w-24 rounded-lg" />
          </div>
        ))}
      </div>
    </div>
  );
};

export const DashboardSkeleton: React.FC = () => {
  return (
    <div className="space-y-8">
      <div className="flex justify-between items-end">
        <div className="space-y-4">
          <Skeleton className="h-8 w-48 rounded-full" />
          <Skeleton className="h-12 w-96 rounded-xl" />
          <Skeleton className="h-6 w-64 rounded-lg" />
        </div>
        <Skeleton className="h-16 w-64 rounded-3xl" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} className="h-32 rounded-[2rem]" />
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <Skeleton className="h-[400px] rounded-[3rem]" />
        <Skeleton className="h-[400px] rounded-[3rem]" />
      </div>
    </div>
  );
};
